//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import AuthMixin from '@motionelements/core/src/components/mixins/auth.mixin.js';
import {
  faArrowRightToBracket,
  faPercent,
  faArrowDownToLine,
  faArrowRight,
} from '@fortawesome/pro-light-svg-icons';

export default {
  name: 'SubscribePromoSteps',
  mixins: [AuthMixin],
  props: {
    subscribePlanLink: {
      type: String,
      required: true,
    },
    discountPercent: {
      type: Number,
      required: true,
    },
  },
  components: {
    HomeBenefits: () => import('@/components/home-page/HomeBenefits.vue'),
    StepItemHorizontal: () => import('@/components/core/elements/StepItemHorizontal.vue'),
    SubscribePromoButton: () => import('./SubscribePromoButton.vue'),
  },
  data() {
    return {
      faArrowRightToBracket,
      faPercent,
      faArrowDownToLine,
      faArrowRight,
    };
  },
  computed: {
    ...mapState({
      isMember: state => state.user.isLoggedIn,
    }),
  },
};
